/**
 * Utility functions to assist with models
 */
import _ from 'underscore';
import Radio from 'backbone.radio';
import v5_Collection from '@/collections/v5/collection';

    var apiCh = Radio.channel('api');
    /**
     * Create a collection of things that belong to a v5_Model, but
     * which come from a global collection. e.g. for a devicegroup,
     *   - webhooks
     *   - devices
     * This will create a collection which listens to additions and changes 
     * on the global collection and then adds or removes them based on basic
     * criteria (i.e. the relationship of the item to the devicegroup).
     *
     * @param v5_model the model we're creating a collection for
     * @param coll_type the type of the global collection, 'webhook', 'device'
     * @param inverse_relname the name the related model uses for v5_model
     * @param rel_url the url func to use for the collection
     * @param fetch_filter the filter object to use when fetching (i.e. ajax params)
     *          {
     *              'filter[devicegroup.id]': devicegroup.id
     *          }
     */
    function create_relationship_collection(
        v5_model, 
        coll_type, 
        inverse_relname, 
        rel_url,
        fetch_filter
    ) {
        var c = new v5_Collection();
        var global_coll = apiCh.request(coll_type);
        // The main url is used for putting and deleting relationships, e.g.
        c.url = rel_url;
        // For fetches, we fetch from the main collection because many (all?)
        // of the relationships endpoints don't support GET
        c.fetch = function fetch(options) {
            // If we didn't get global_coll just use the local collection
            var coll = global_coll || c;
            options = options || {};
            options.data = _.extend(fetch_filter, options.data);
            return v5_Collection.prototype.fetch.call(coll, options);
        };

        // Listen for additions to global_coll; if a new rel_model belongs to
        // this v5_model, add it to the collection
        if (global_coll) {
            v5_model.listenTo(global_coll, 'add change', function(rel_model) {
                var item = rel_model.rel.get(inverse_relname);
                if (item && item.id === v5_model.id) {
                    c.add(rel_model);
                } else {
                    c.remove(rel_model);
                }
            });
        }
        return c;
    }
    export default {
        create_relationship_collection: create_relationship_collection
    };

